"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.environment = exports.commerceErrorUrl = exports.dcoUrl = exports.commerceDataAggregatorUrl = void 0;
var tslib_1 = require("tslib");
var app_config_production_json_1 = tslib_1.__importDefault(require("./app-config.production.json"));
var app_config_development_json_1 = tslib_1.__importDefault(require("./app-config.development.json"));
exports.commerceDataAggregatorUrl = "/checkout/_ajax/commercedataaggregator/v2";
exports.dcoUrl = "/placeorder";
exports.commerceErrorUrl = "/checkout/_ajax/commerceerrors";
var availableEnvironments = ["production", "test", "development"];
// already covered but keeps complaining
/* istanbul ignore next */
var CHEGG_ENV = (_a = process.env.CHEGG_ENV) !== null && _a !== void 0 ? _a : "development";
exports.environment = availableEnvironments.includes(CHEGG_ENV)
    ? CHEGG_ENV
    : "development";
exports.default = exports.environment === "production" ? app_config_production_json_1.default : app_config_development_json_1.default;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/pricing-sdk/dist/lib-esm/Config/index.js
// module id = 1336
// module chunks = 11